import { Injectable, signal } from '@angular/core';
import { IAuthenticatedUser } from '@domain/auth';

@Injectable({ providedIn: 'root' })
export class AuthStore {
  readonly #user = signal<IAuthenticatedUser | null>(null);
  readonly #loading = signal(false);
  readonly #error = signal<string | null>(null);
  readonly #token = signal<string | null>(null);

  readonly user = this.#user.asReadonly();
  readonly loading = this.#loading.asReadonly();
  readonly error = this.#error.asReadonly();
  readonly token = this.#token.asReadonly();

  public setToken(token: string | null): void {
    this.#token.set(token);
  }

  public setUser(user: IAuthenticatedUser | null): void {
    this.#user.set(user);
  }

  public setLoading(loading: boolean): void {
    this.#loading.set(loading);
  }

  public setError(error: string | null): void {
    this.#error.set(error);
  }
}
